// @flow

import * as React from 'react';

import s from './Input.scss';

type Props = {
  label: string|number,
  value: string|number,
  name: string|number,
  placeholder: string|number,
  onChange: (e: SyntheticEvent<any>) => void,
  disabled: boolean,
  hasError: boolean,
  className?: string,
  subtext?: string,
}

const Input = ({
  label,
  value,
  name,
  placeholder,
  onChange,
  disabled,
  hasError,
  className,
  subtext,
  ...clonedProps
}: Props) => {
  const inputStyle = hasError ? [s.Input, s.Input_error] : [s.Input];
  if (className) inputStyle.push(className);
  const subtextClasses = hasError ? [s.Input_subtext, s.Input_subtext__error] : [s.Input_subtext];
  return (
    <React.Fragment>
      <label className={s.Input_label}>
        { label }
      </label>
      <input
        className={inputStyle.join(' ')}
        type="text"
        value={value}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        {...clonedProps}
      />
      { subtext && <p className={subtextClasses.join(' ')}>{subtext}</p> }
    </React.Fragment>
  )
}



export default Input;
